// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlaceMap-root-mdFSp {
	background: var(--primary-white-bg);
	color: var(--common-text-color);
	padding: 0px;
}

.PlaceMap-container-XFwA1 {
	margin: 0 auto;
	padding: 0px;
	max-width: var(--max-container-width);
}

.PlaceMap-alertContainer-bp988 {
	padding: 12px 25px;
	position: relative;
	font-size: 14px;
	color: var(--white-text);
	border-radius: 6px 6px 0 0;
	font-weight: 400;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 1;
}

.PlaceMap-alertDanger-E20AW {
	background: #000000c4;
}

.PlaceMap-dangerIcon-wzFyT {
	padding-right: 8px;
}

.PlaceMap-alertSuccess-m6ynv {
	background: #14a64acc;
}

.PlaceMap-successIcon-vvarT {
	padding-right: 8px;
}

.PlaceMap-mapSection-WEtfJ {
	position: relative;
}

@media screen and (max-width: 991px) {
	.PlaceMap-tabViewMap-DfD85 {
		height: 75vh !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/PlaceMap/PlaceMap.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,+BAA+B;CAC/B,YAAY;AACb;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,qCAAqC;AACtC;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,wBAAwB;CACxB,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD","sourcesContent":[".root {\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tpadding: 0px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0px;\n\tmax-width: var(--max-container-width);\n}\n\n.alertContainer {\n\tpadding: 12px 25px;\n\tposition: relative;\n\tfont-size: 14px;\n\tcolor: var(--white-text);\n\tborder-radius: 6px 6px 0 0;\n\tfont-weight: 400;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n\tz-index: 1;\n}\n\n.alertDanger {\n\tbackground: #000000c4;\n}\n\n.dangerIcon {\n\tpadding-right: 8px;\n}\n\n.alertSuccess {\n\tbackground: #14a64acc;\n}\n\n.successIcon {\n\tpadding-right: 8px;\n}\n\n.mapSection {\n\tposition: relative;\n}\n\n@media screen and (max-width: 991px) {\n\t.tabViewMap {\n\t\theight: 75vh !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PlaceMap-root-mdFSp`,
	"container": `PlaceMap-container-XFwA1`,
	"alertContainer": `PlaceMap-alertContainer-bp988`,
	"alertDanger": `PlaceMap-alertDanger-E20AW`,
	"dangerIcon": `PlaceMap-dangerIcon-wzFyT`,
	"alertSuccess": `PlaceMap-alertSuccess-m6ynv`,
	"successIcon": `PlaceMap-successIcon-vvarT`,
	"mapSection": `PlaceMap-mapSection-WEtfJ`,
	"tabViewMap": `PlaceMap-tabViewMap-DfD85`
};
module.exports = ___CSS_LOADER_EXPORT___;
